import React, { useCallback, useMemo, useState } from "react";
import _ from "lodash";

import { SearchPanel } from "../../components/SearchPanel/SearchPanel";
import { GlobalSearchContext } from "../../context/globalSearch.context";
import { useApi } from "../../utils/useApi";
import { CSSTransition } from "react-transition-group";

const initState = {
	searchField: "",
	types: null,
};
export const GlobalSearch = () => {
	const [isOpen, setIsOpen] = useState(false);

	const [search, setSearch] = useState(initState);

	const {  lang = "en" } = window["local_data"];

	const {
		groups: data,
		request,
		makeRequest,
		// lang,
	} = useApi(search.searchField, search.types);

	const handleToggleOpen = useCallback(
		() => setIsOpen(!isOpen),
		[isOpen, setIsOpen]
	);

	const handleSetSearchField = useCallback((searchField) => {
		setSearch((s) => ({ ...s, searchField }));
	}, []);

	const handleSetTypes = useCallback((types) => {
		setSearch((s) => ({ ...s, types }));
	}, []);

	const dataFormatter = useCallback(
		(data) =>
			_.map(data, (group) => ({
				...group,
				resultItems: _.map(group.resultItems, (item) => ({
					id: item.id,
					title: item.title?parseHtmlEnteties(item.title):item.title,
					link: item.url,
					imageMarkup: item?.images.markup || null,
				})),
			})),
		[]
	);
	// title: item.title?item.title.replaceAll('&#038;', '&').replaceAll('&#8211;', '-').replaceAll('&#8243;', '"').replaceAll('&#8230;', '...').replaceAll('&#8217;', '\''):item.title,
	const parseHtmlEnteties = (str) => {
		return str.replace(/&#([0-9]{1,4});/gi, function(match, numStr) {
			var num = parseInt(numStr, 10); // read num as normal number
			return String.fromCharCode(num);
		});
	}
	

	const isArabic = lang.toLowerCase().includes("ar");

	console.log("isArabic", isArabic, lang.toLowerCase().includes("ar"), lang);

	const groups = useMemo(
		() => data.length && dataFormatter(data),
		[data, dataFormatter]
	);

	return (
		<GlobalSearchContext.Provider
			value={{
				groups,
				request,
				handleToggleOpen,
				handleSetTypes,
				handleSetSearchField,
				makeRequest,
				isArabic,
			}}
		>
			<div onClick={handleToggleOpen}> {isArabic ? "بحث" : "Search"}</div>
			<CSSTransition
				in={isOpen}
				appear={true}
				timeout={300}
				classNames="fade"
				unmountOnExit
			>
				<SearchPanel />
			</CSSTransition>
		</GlobalSearchContext.Provider>
	);
};
